import getHelper from '../../../services/getHelper';

export default getHelper('/session-terms-permissions');
